import React from "react";
import type {VoidFunctionComponent} from "react";
import s from "./SongDetailsLessonPlayAction.module.scss";
import {useSongDetailsLessonPlayActionLogic} from "./SongDetailsLessonPlayAction.logic";

export interface ISongDetailsLessonPlayActionProps {
}

export const SongDetailsLessonPlayAction: VoidFunctionComponent<ISongDetailsLessonPlayActionProps> = ({}) => {
  const {navigateToLessonPlayerHandler} = useSongDetailsLessonPlayActionLogic();
  return <button className={s.playNow} onClick={navigateToLessonPlayerHandler}>Play Now</button>;
}

